"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _constants = require("../../constants");

var _images = require("../../images");

var _app = require("../../store/reducers/app");

var _conversation = require("../../store/reducers/conversation");

var _app2 = require("../../store/selectors/app");

var _conversation2 = require("../../store/selectors/conversation");

var _util = require("../../util");

var _index = require("./index");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var Text =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Text, _PureComponent);

  function Text() {
    _classCallCheck(this, Text);

    return _possibleConstructorReturn(this, _getPrototypeOf(Text).apply(this, arguments));
  }

  _createClass(Text, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          appEnv = _this$props.appEnv,
          conversation = _this$props.conversation,
          index = _this$props.index,
          items = _this$props.items,
          type = _this$props.type;
      var text = items[0];
      var agentImageSrc = items[1] ? items[1] : '';
      var avatarImageSrc = type === _constants.CONVERSATION_TYPE_TEXT_HUMAN ? agentImageSrc : _images.iconChat;
      var fallbackImageSrc = type === _constants.CONVERSATION_TYPE_TEXT_HUMAN ? "".concat((0, _util.getCdnPath)(appEnv), "/images/godaddy-guides-faces.jpg") : _images.iconChat;
      var hidden = conversation[index - 1] && conversation[index - 1].participantId === conversation[index].participantId;
      return _react["default"].createElement(_react.Fragment, null, _react["default"].createElement(_index.AvatarWrapper, {
        hidden: hidden,
        src: avatarImageSrc,
        fallback: fallbackImageSrc
      }, _react["default"].createElement("div", {
        className: (0, _classnames["default"])('help--speech-bubble', 'help--speech-bubble-left', type === _constants.CONVERSATION_TYPE_TEXT_HUMAN ? 'help--speech-bubble-agent' : null)
      }, _react["default"].createElement(_index.Linkify, _extends({
        text: text
      }, this.props)))));
    }
  }]);

  return Text;
}(_react.PureComponent);

Text.propTypes = {
  appEnv: _app.appPropTypes.env,
  items: _propTypes["default"].arrayOf(_propTypes["default"].string).isRequired,
  conversation: _conversation.conversationPropTypes.base,
  type: _propTypes["default"].string.isRequired,
  timestamp: _propTypes["default"].number,
  index: _propTypes["default"].number
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    appEnv: (0, _app2.getAppEnv)(state),
    conversation: (0, _conversation2.getConversation)(state)
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps)(Text);

exports["default"] = _default;